import React, { useEffect, useMemo, useRef, useState } from "react";
import apiRoutes from "../../api/apiRoutes";
import { apiFetchJson } from "../../utils/http";

const PAGE_SIZE = 200;

export default function ProductoMultiSelect({
  value = [],
  onChange = () => {},
  disabled = false,
}) {
  const ref = useRef(null);

  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");

  // ===== precarga completa =====
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        let page = 0;
        let hasMore = true;
        const acc = [];

        while (hasMore) {
          const url = apiRoutes.productoTarjeta.autocompleteUrl(
            "producto",
            "",
            page,
            PAGE_SIZE,
            true
          );
          const data = await apiFetchJson(url);
          const rows = data?.items ?? [];
          acc.push(...rows.map((r) => ({ id: r.id, label: r.label })));
          hasMore = Boolean(data?.hasMore);
          page++;
        }

        if (!cancelled) setItems(acc);
      } catch (e) {
        console.error("Productos:", e);
      }
    })();

    return () => (cancelled = true);
  }, []);

  // ===== click afuera =====
  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const filtered = useMemo(() => {
    const q = search.toLowerCase().trim();
    if (!q) return items;
    return items.filter((i) =>
      `${i.id} ${i.label}`.toLowerCase().includes(q)
    );
  }, [items, search]);

  const label =
    value.length === 0
      ? "Seleccionar"
      : value.length === 1
      ? "1 seleccionado"
      : `${value.length} seleccionados`;

  const toggle = (id) =>
    onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);

  const marcarTodas = () => onChange(filtered.map((f) => f.id));
  const desmarcarTodas = () =>
    onChange(value.filter((id) => !filtered.some((f) => f.id === id)));

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        disabled={disabled}
        className="input w-full flex items-center text-left"
        onClick={() => setOpen((v) => !v)}
      >
        <span className="truncate">{label}</span>
        <span className="ml-auto">▾</span>
      </button>

      {open && (
        <div className="absolute z-50 mt-1 w-full border rounded bg-white shadow-xl">
            {/* HEADER FIJO */}
            <div className="p-2 border-b bg-gray-50 flex flex-wrap gap-2">
            <input
                placeholder="Filtrar registro"
                className="flex-1 border rounded px-2 py-1"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            <button onClick={marcarTodas} className="text-green-700 text-sm">
                ✓ Marcar todas
            </button>
            <button onClick={desmarcarTodas} className="text-green-700 text-sm">
                ✗ Desmarcar todas
            </button>
            </div>

            {/* LISTA CON SCROLL */}
            <div className="max-h-56 overflow-auto">
            {filtered.map((op) => (
                <label
                key={op.id}
                className="flex items-center gap-2 px-3 py-2 hover:bg-gray-50 cursor-pointer"
                >
                <input
                    type="checkbox"
                    checked={value.includes(op.id)}
                    onChange={() => toggle(op.id)}
                />
                <span className="truncate">{op.label}</span>
                </label>
            ))}

            {filtered.length === 0 && (
                <div className="px-3 py-2 text-sm text-gray-500">
                Sin coincidencias
                </div>
            )}
            </div>

            {/* FOOTER FIJO */}
            <div className="p-2 border-t text-right bg-white">
            <button
                type="button"
                className="text-green-700"
                onClick={() => setOpen(false)}
            >
                Cerrar
            </button>
            </div>
        </div>
        )}

    </div>
  );
}
